import * as etree from 'elementtree';

export const setHeight = (template, values) => {
    const sheet = template.loadSheet(1);

    const root = sheet.root;

    const rows = root.findall(".//row");
    
    rows.forEach(row => {
        const rowNumber = parseInt(row.attrib.r);
        if (rowNumber in values) {
            row.attrib.ht = "" + values[rowNumber]; 
            row.attrib.customHeight = '1'; 
        }
    });

    // Обновляем файл в архиве
    template.archive.file(sheet.filename, etree.tostring(sheet.root));
}
